module.exports = __webpack_public_path__ + "img/lt-box4.095ad291.png";